// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_ab980d6","bonusInput":"_fbcc37b"};